import { TranslateConfigService } from '@core/translate-config.service';
import { CURRENCIES } from '@shared/constants/currency.constants';
import { CurrencyEnum } from '@shared/models/enums/currency.enum';
import { PricingModelEnum } from '@shared/models/enums/pricingModel.enum';
import { DeviceType, DeviceTypeTranslations } from '@shared/models/enums/deviceType.enum';

export function formatMoney(value: number | string | undefined, currency: string): string {
  if (value == null || value === '') {
    return '-';
  }
  const formattedValue = value.toLocaleString('sv-SE');
  return currency ? `${formattedValue} ${currency}` : formattedValue;
}

export function pricingModelExpandedTooltip(translateConfigService: TranslateConfigService, code: string): string {
  if (!code || code === '-') {
    return '';
  }
  const key = `campaign.advertising.pricingModelExpanded.${code.toLowerCase()}`;
  const translated = translateConfigService.instant(key);
  return translated === key ? '' : translated;
}

export function pricingModelIdToCode(model: PricingModelEnum | null | undefined): string {
  if (model == null) {
    return '';
  }
  switch (model) {
    case PricingModelEnum.CPP:
      return 'CPP';
    case PricingModelEnum.CPV:
      return 'CPV';
    case PricingModelEnum.FP:
      return 'FP';
    default:
      return '';
  }
}

export function currencyIdToCode(currencyId: CurrencyEnum | null | undefined): string {
  if (currencyId == null) {
    return '';
  }
  return CURRENCIES.find(c => c.id === currencyId)?.name ?? '';
}

export function getDeviceTypeLabels(translateConfigService: TranslateConfigService): Record<number, string> {
  return {
    [DeviceType.ScreenOnly]: translateConfigService.instant(DeviceTypeTranslations[DeviceType.ScreenOnly]),
    [DeviceType.SensorOnly]: translateConfigService.instant(DeviceTypeTranslations[DeviceType.SensorOnly]),
    [DeviceType.ScreenWithSensor]: translateConfigService.instant(DeviceTypeTranslations[DeviceType.ScreenWithSensor]),
  };
}
